import { http } from '../../config/axios'
import { UserCredentials } from '../../interface/UserCredentials'
import { AuthenticationResponse } from '../postLogin/postLoginService'

export interface UserCredentialsDuploFator extends UserCredentials {
  // código de 6 dígitos gerado pelo app autenticador
  codigo: string
}

export default function postAuthenticationDuploFator(
  payload: UserCredentialsDuploFator
): Promise<AuthenticationResponse> {
  return http
    .post('api/gatewaybiro/authentication-duplo-fator', payload, {
      headers: {
        'originLogin': 'web'
      }
    })
    .then((res) => {
      return res.data as AuthenticationResponse
    })
    .catch((error) => {
      console.error('Erro ao validar duplo fator', error)
      throw Error(error.response?.data)
    })
}
